import React from "react";
import Movie from "../Components/Movie";
import movies from "../Components/Movie.json";
import "../Css/Movie.css";
import { useEffect } from "react";

export default function MovieReview() {
  useEffect(() => {
    document.title = "Movie-Review";
  }, []);

  return (
    <div id="moviebackset">
      <div
        className="container-fluid fixed-bottom"
        style={{ boxShadow: "0px 0px 15px 2px var(--box-shadow)" }}
      ></div>

      <div className="container-fluid">
        <div className="row morow">
          {movies.map((element, index) => {
            return (
              <Movie
                key={index}
                img={element.Poster}
                title={element.Title}
                Year={element.Year}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}
